class PopupComponent extends HTMLElement {
  constructor() {
    super();

    const popup = document.querySelector(".navigation_popup");
    const popupContent = document.querySelector(".popup-content");
    const bodyEl = document.querySelector("body");

    const closeBtn = document.createElement("span");
    closeBtn.classList.add("close");
    closeBtn.textContent = "×";

    popupContent.appendChild(closeBtn);

    closeBtn.addEventListener("click", () => {
      popup.classList.add("hidden");
      bodyEl.style.overflow = "visible";
    });

    window.addEventListener("click", (e) => {
      if (e.target === popup) {
        popup.classList.add("hidden");
        bodyEl.style.overflow = "visible";
      }
    });

    this.openPopup = function () {
      popup.classList.remove("hidden");
      bodyEl.style.overflow = "hidden";
    };
  }

  connectedCallback() {
    const openPopupBtn = document.getElementById("openPopup");
    if (openPopupBtn) {
      openPopupBtn.addEventListener("click", () => {
        this.openPopup();
      });
    }
  }
}

customElements.define("popup-component", PopupComponent);

document.addEventListener("DOMContentLoaded", function () {
  // open navigation on click "Navigation" item START
  //   const navigationHeaderEls = document.querySelectorAll(".navigation-header");

  //   navigationHeaderEls.forEach( el => {
  //     el.addEventListener("click", function () {
  //       const menu = el.nextElementSibling;

  //       const arrowDown = el.querySelector(".icon-arrow-down");
  //       const arrowUp = el.querySelector(".icon-arrow-up");

  //       setTimeout(() => {
  //         if (menu.classList.contains("open")) {
  //           const anim = menu.animate([{ height: `${menu.scrollHeight}px` }, { height: `0px` }], 1000);
  //           anim.finished.then(() => {
  //             menu.classList.remove("open");
  //             menu.style.height = "0px";
  //             arrowUp.style.display = "none";
  //             arrowDown.style.display = "block";
  //           });
  //         } else {
  //           const anim = menu.animate([{ height: `0px` }, { height: `${menu.scrollHeight}px` }], 1000);
  //           anim.finished.then(() => {
  //             menu.classList.add("open");
  //             menu.style.height = `${menu.scrollHeight}px`;
  //             arrowDown.style.display = "none";
  //             arrowUp.style.display = "block";
  //           });
  //         }
  //       }, 1000);
  //   });
  // })
  // open navigation on click "Navigation" item END

  const toggles = document.querySelectorAll(".menu-item__head");

  const currentUrl = window.location.href;
  const menuLinks = document.querySelectorAll(".menu a");

  if (window.location.pathname === "/") {
    localStorage.removeItem("activeCollection");
  }

  //   const recommendationLinks = document.querySelector(
  //     ".related-products"
  //   );

  //   console.log("recommendationLinks", recommendationLinks);

  // if (recommendationLinks) {
  //     recommendationLinks.addEventListener("click", () => {
  //       localStorage.removeItem("activeCollection");
  //     });
  // }

  const allProducts = document.querySelector("#HeaderMenu-produkter");
  if (allProducts) {
    allProducts.addEventListener("click", () => {
      localStorage.removeItem("activeCollection");
    });
  }

  const activeCollection = localStorage.getItem("activeCollection");
  const activeheadMenuItem = localStorage.getItem("activeheadMenuItem");

  menuLinks.forEach((link) => {
    const parentTitle = link.getAttribute("data-title");
    link.addEventListener("click", function () {
      localStorage.setItem("activeCollection", link.href);
    });

    if (window.location.pathname.includes("/products/")) {
      if (link.href === activeCollection) {
        link.parentElement.classList.add("active-link");

        const parentSubmenu = link.closest(".submenu");
        if (parentSubmenu) {
          parentSubmenu.style.maxHeight = "fit-content";
          const parentMenuHead = parentSubmenu.previousElementSibling;
          parentMenuHead.classList.add("active");
        }

        const parentSubsubmenu = link.closest(".sub-submenu");
        if (parentSubsubmenu) {
          parentSubsubmenu.style.maxHeight =
            parentSubsubmenu.scrollHeight + "px";
          const parentSubmenuHead = parentSubsubmenu
            .closest(".submenu-item")
            .querySelector(".menu-item__head");
          parentSubmenuHead.classList.add("active");
        }
      }
    } else {
      if (link.href === currentUrl && parentTitle === activeheadMenuItem) {
        link.parentElement.classList.add("active-link");

        const parentSubmenu = link.closest(".submenu");
        if (parentSubmenu) {
          parentSubmenu.style.maxHeight = "fit-content";
          const parentMenuHead = parentSubmenu.previousElementSibling;
          parentMenuHead.classList.add("active");
        }

        const parentSubsubmenu = link.closest(".sub-submenu");
        if (parentSubsubmenu) {
          parentSubsubmenu.style.maxHeight =
            parentSubsubmenu.scrollHeight + "px";
          const parentSubmenuHead = parentSubsubmenu
            .closest(".submenu-item")
            .querySelector(".menu-item__head");
          parentSubmenuHead.classList.add("active");
        }
      }
    }
  });

  toggles.forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      toggle.classList.toggle("active");

      const headMenuItem = toggle.getAttribute("data-title");

      localStorage.setItem("activeheadMenuItem", headMenuItem);

      const submenu = this.nextElementSibling;
      if (submenu) {
        if (submenu.style.maxHeight && submenu.style.maxHeight !== "0px") {
          submenu.style.maxHeight = "0px";
        } else {
          // const subsubmenu = submenu.querySelector(".sub-submenu");
          // const submenuHeight = submenu.scrollHeight;
          // const subsubmenuHeight = subsubmenu ? subsubmenu.scrollHeight : 0;
          // submenu.style.maxHeight = submenuHeight + subsubmenuHeight + "px";
          submenu.style.maxHeight = "fit-content";
        }

        const plusIcon = this.querySelector(".icon-plus");
        const minusIcon = this.querySelector(".icon-minus");

        if (submenu?.style.maxHeight !== "0px") {
          plusIcon.style.display = "none";
          minusIcon.style.display = "inline";
        } else {
          plusIcon.style.display = "inline";
          minusIcon.style.display = "none";
        }
      }
    });
  });
});
